export default {
  recapTitle: {
    id: 'search_recap_title',
    defaultMessage: 'Your search:',
  },
}
